import React from 'react';
import { Route } from 'react-router';
import { legacyPaths } from 'app/navigation';
import * as Screens from './screens';

/** Route elements that render the legacy application inside the iframe bridge. */
export const legacyRoutes = legacyPaths.map(legacyPath => <Route path={`${legacyPath.path}/*`} caseSensitive element={<Screens.LegacyIframe />} key="legacyIframe" />);